<template>
  <div>

    <Loading :show="!loaded" />

    <div class="settings">

      <div style="display: flex;margin-bottom: 2em;">
        <div style="width:50%;">
          <input type="text" v-model="freesearch" placeholder="Sök" />
        </div>
        <div>
          &nbsp;&nbsp;
          <input type="checkbox" v-model="show_winter" /> Vinter
          &nbsp;&nbsp;
          <input type="checkbox" v-model="show_summer" /> Sommar
        </div>
      </div>
      
      <div v-for="(s, i) in settings" :class="'setting-group'">
        <div class="setting-group-title" @click="s.expanded = !s.expanded">{{ getTitle(i) }} <span v-if="!s.expanded" class="title-helper">{{ getHelp(s) }}</span></div>
        <div :class="(s.expanded ? 'setting-list--expanded' : 'setting-list')">
          <div v-for="group in s.entries" :class="'setting-group-inner'">
            <div class="inner-title">{{ group.title }}</div>
            <div v-for="setting in group.entries" v-if="showSetting(setting)" class="single-setting-wrapper">
              <Setting :setting="setting" />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import API from '@/classes/API';
import Setting from '@/components/Admin/Setting';
import Loading from '@/components/components/Loading';

export default {
  components: {
    Loading,
    Setting,
  },
  data() {
    return {
      settings: [],
      show_winter: true,
      show_summer: true,
      freesearch: '',
      loaded: false,
    };
  },
  async mounted() {
    const { data } = await API.get('/settings');
    this.settings = data;
    this.loaded = true;
  },
  computed: {
  },
  methods: {
    showSetting(setting) {
      if (setting.season) {
        if (!this.show_winter && setting.season === 'winter') {
          return false;
        }

        if (!this.show_summer && setting.season === 'summer') {
          return false;
        }
      }

      if (this.freesearch) {
        let dbValue = (setting.db && setting.db.value) ? setting.db.value : '';

        if (typeof dbValue === 'object') {
          dbValue = JSON.stringify(dbValue);
        }

        const stringToSearch = [
          setting.title,
          setting.description,
          setting.value,
          ((setting.db && setting.db.example) ? setting.db.example : ''),
          ((setting.db && setting.db.default_value) ? setting.db.default_value : ''),
          dbValue,
          ((setting.db && setting.db.key) ? setting.db.key : ''),
        ].join(' ').toLowerCase();

        return stringToSearch.match(this.freesearch.toLowerCase());
      }

      return true;
    },
    getTitle(key) {
      const titles = {
        styling: 'Utseende',
        payment: 'Betalning',
        dates: 'Datum',
        open: 'Öppet/stängt',
        accommodation: 'Boende',
        system: 'System',
        texts: 'Texter',
        skischool: 'Skidskola',
        mypage: 'Mina sidor',
        rental: 'Hyra',
      };

      if (titles[key]) {
        return titles[key];
      }

      return key.charAt(0).toUpperCase() + key.slice(1);
    },
    getHelp(group) {
      const titles = [];

      // eslint-disable-next-line
      for (const firstGroup of group.entries) {
        // eslint-disable-next-line
        for (const setting of firstGroup.entries) {
          titles.push(setting.title);
        }
      }

      return titles.join(', ');
    },
  },
};
</script>

<style lang="stylus">
.admin-outer-wrapper .settings
  &:focus-within .single-setting-wrapper
    filter grayscale(1) blur(1px)
    opacity 0.5
  .single-setting-wrapper:focus-within
    filter grayscale(0)
    opacity 1

</style>

<style scoped lang="stylus">
@import '~@/global.styl'

.settings
  admin-container()

.inner-title
  font-weight bold
  font-size 18px
  line-height: 24px
  padding: 20px 40px
  background-color: #a4c3d2
  color black
  display flex

.setting-group-title
  font-weight bold
  font-size 18px
  line-height: 24px
  cursor pointer
  padding: 20px 20px
  background-color: #005580
  color white
  display flex
  // text-transform: uppercase
  .title-helper
    font-size: 13px
    line-height: 24px
    opacity: 0.8
    font-weight normal
    margin-left 2em
    text-overflow: ellipsis
    overflow: hidden
    white-space: nowrap

.setting-group
  margin-bottom 30px
  background-color #ecf5f8
  display none
  &:has(.setting)
    display block

.setting-group-inner
  display none
  &:has(.setting)
    display block

.setting-list
  max-height: 0
  overflow: hidden
  &--expanded
    max-height: auto
</style>



// WEBPACK FOOTER //
// Settings.vue?7a92e2b0